import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { Card } from "react-bootstrap";
import React from "react";
import { useTranslation } from "react-i18next";

const SelectStatus = (props) => {
  const translateForm = "global";
  const { t } = useTranslation();
  const {
    data,
    handleInputChange,
    disabled = false,
    archiveType = false,
  } = props;

  return (
    <Card>
      <Card.Header>{t(`${translateForm}.publish`)}</Card.Header>
      <Card.Body>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">
            {t(`${translateForm}.status`)}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={data.status}
            label="Status"
            name="status"
            onChange={handleInputChange}
            size="small"
            disabled={disabled}
          >
            <MenuItem value="ACTIVE">{t(`${translateForm}.active`)}</MenuItem>
            <MenuItem value="INACTIVE">
              {t(`${translateForm}.inactive`)}
            </MenuItem>
            {archiveType && (
              <MenuItem value="ARCHIVE">
                {t(`${translateForm}.archive`)}
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </Card.Body>
    </Card>
  );
};

export default SelectStatus;
